import React, { Component, Fragment } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { CompanyActions } from '../../store/actions/companies';
import Header from '../../components/Header';

import Organizations from './Oganizations';
import Users from './Users';
import UserDetails from './Users/Details';
import VoicebotSettings from './Voicebot';
import General from './General';
import Footer from '../../components/Footer2';

import './styles.scss';

import { UserActions } from '../../store/actions/users';
import { PermissionActions } from '../../store/actions/permissions';

import BOOutlineButton from '../../components/Widgets/Forms/BOOutlineButton';

const CurrentMenu = {
  organizations: 'organizacoes',
  users: 'usuarios',
  voicebot: 'voicebot',
  general: 'geral',
};

class Settings extends Component {
  state = {
    menu: CurrentMenu.general,
    isActive: false,
    searchValue: '',
  };

  componentDidMount() {
    const { userMe, companies, organizations, permissions } = this.props;

    if (userMe && !organizations) {
      this.doGetOrganizations({ companyId: userMe.selectedCompany._id });
    }
    this.doGetUsers();

    if (!companies) {
      this.doGetCompanies();
    }

    if (!permissions || permissions.length === 0) {
      this.doGetPermissions();
    }
  }

  doGetPermissions = () => {
    const { getPermissions } = this.props;
    getPermissions();
  };

  doGetOrganizations = (term) => {
    const { getOrganizations } = this.props;
    getOrganizations(term);
  };

  doGetCompanies = (term) => {
    const { getCompanies } = this.props;
    getCompanies(term);
  };

  doGetUsers = (term) => {
    const { getUsers } = this.props;
    getUsers(term);
  };

  onSearchChanged = (value) => {
    this.setState({
      searchValue: value,
    });
  };

  setCurrentMenu = (menu) => {
    this.setState({ menu });
    this.setState({ searchValue: '' });
    switch (menu) {
      case CurrentMenu.voicebot:
      case CurrentMenu.users: {
        break;
      }
      case CurrentMenu.organizations: {
        break;
      }
      case CurrentMenu.general: {
        break;
      }
      default:
        break;
    }
    this.props.history.push(`/preferencias/${menu}`);
  };

  getModalDataTarget = () => {
    const { menu } = this.state;
    switch (menu) {
      case CurrentMenu.organizations:
        return 'addOrganizationModal';
      case CurrentMenu.users:
        return 'addUserModal';
      default:
        return 'addOrganizationModal';
    }
  };

  getOpenStatusModal = () => {
    const { menu, isActive } = this.state;
    if (menu === 'usuarios' || menu === 'organizacoes') {
      this.setState({ isActive: !isActive });
    }
  };

  render() {
    const {
      i18n,
      userMe,
      companies,
      organizations,
      users,
      permissions,
      match,
      history,
      getPermissionsCompleted,
      getOrganizationsCompleted,
      updateCompany,
      getPermission,
    } = this.props;

    const { menu, searchValue } = this.state;

    const modalDataTarget = this.getModalDataTarget();

    let contentTitle = i18n.t('Setores');
    let content = (
      <Organizations
        searchValue={this.state.searchValue}
        organizations={organizations}
        {...this.props}
        isActive={this.state.isActive}
        getOpenStatusModal={this.getOpenStatusModal}
      />
    );

    let editingUser = false;
    switch (menu) {
      case CurrentMenu.voicebot: {
        contentTitle = 'Configurar instâncias do voicebot';
        content = <VoicebotSettings />;
        break;
      }

      case CurrentMenu.users: {
        if (match.params.userId) {
          const button = (
            <BOOutlineButton
              className="user-edit-btn-cancel"
              onClick={() => history.goBack()}
            >
              cancelar
            </BOOutlineButton>
          );
          contentTitle = (
            <Fragment>
              <span className="user-edit-title1">Usuários</span>
              <span className="user-edit-title2">Dados do Usuário</span>
              {button}
            </Fragment>
          );
          const user = users
            ? users.find((i) => i._id === match.params.userId)
            : undefined;
          if (user && getPermissionsCompleted && getOrganizationsCompleted) {
            content = (
              <UserDetails
                userId={match.params.userId}
                user={user}
                {...this.props}
              />
            );
          } else {
            content = <div />;
          }

          editingUser = true;
        } else {
          contentTitle = i18n.t('Usuários');
          content = (
            <Users
              searchValue={this.state.searchValue}
              getModalDataTarget={this.getModalDataTarget}
              users={users}
              organizations={organizations}
              permissions={permissions}
              {...this.props}
              getPermission={getPermission}
              isActive={this.state.isActive}
              getOpenStatusModal={this.getOpenStatusModal}
            />
          );
        }
        break;
      }
      default:
        break;
    }

    if (userMe?.claim?.name === 'User' || userMe?.claim?.name === 'Viewer') {
      return <Redirect to="/home" />;
    }

    return (
      <Fragment>
        <Header pagetype="page-inicio" />
        <div className="row settings-content">
          <div className="row vw-100">
            <div className="col-md-12">
              <div className="col-md-10 d-flex offset-1 mt-5">
                {/* MENU */}
                <div className="col-md-3 settings-content-card settings-content-card-menu mr-4 p-0">
                  <div className="pt-4 pl-3 d-flex align-items-center">
                    <img
                      src={require('../../assets/images/icon_settings.svg')}
                      alt=""
                    />
                    <span className="ml-2 settings-content-card-menu-title">
                      {i18n.t('Preferências')}
                    </span>
                  </div>
                  <div className="pt-3 pb-5">
                    {/*  */}
                    <div
                      className={`menu-item pointer d-flex align-items-center ${menu === CurrentMenu.general ? 'selected' : ''
                        }`}
                      onClick={() => this.setCurrentMenu(CurrentMenu.general)}
                    >
                      <img
                        className="ml-3"
                        src={require('../../assets/images/icone-geral.svg')}
                        alt=""
                      />
                      <span className="ml-1">{i18n.t('Geral')}</span>
                    </div>
                    <hr />
                    {/*  */}
                    <div
                      className={`menu-item pointer d-flex align-items-center ${menu === CurrentMenu.organizations ? 'selected' : ''
                        }`}
                      onClick={() =>
                        this.setCurrentMenu(CurrentMenu.organizations)
                      }
                    >
                      <img
                        className="ml-3"
                        src={require('../../assets/images/icon_setores.svg')}
                        alt=""
                      />
                      <span className="ml-1">{i18n.t('Setores')}</span>
                    </div>
                    <hr />
                    {/*  */}
                    <div
                      className={`menu-item pointer d-flex align-items-center ${menu === CurrentMenu.users ? 'selected' : ''
                        }`}
                      onClick={() => this.setCurrentMenu(CurrentMenu.users)}
                    >
                      <img
                        className="ml-3"
                        src={require('../../assets/images/icon_usuarios_dark.svg')}
                        alt=""
                      />
                      <span className="ml-1">{i18n.t('Usuários')}</span>
                    </div>
                    <hr />
                    {/*  */}
                    <div
                      className={`menu-item pointer d-flex align-items-center ${menu === CurrentMenu.voicebot ? 'selected' : ''
                        }`}
                      onClick={() => this.setCurrentMenu(CurrentMenu.voicebot)}
                    >
                      <img
                        className="ml-3"
                        src={require('../../assets/images/icon_voicebot.svg')}
                        alt=""
                      />
                      <span className="ml-1">{i18n.t('Voicebot')}</span>
                    </div>
                    <hr />
                  </div>
                </div>
                {/* MAIN CONTENT */}
                <div
                  className="col-md-8 settings-content-card settings-content-card-settings ml-4 pt-4 pl-4"
                  style={{ marginBottom: '2rem' }}
                >
                  {menu !== CurrentMenu.general ? (
                    <>
                      <div className="settings-content-card-settings-title">
                        {contentTitle}
                      </div>
                      <div
                        className="settings-search mt-2"
                        hidden={editingUser || menu === CurrentMenu.voicebot}
                      >
                        <input
                          className="w-100"
                          placeholder={i18n.t('pesquisar')}
                          value={searchValue}
                          onChange={(e) => this.onSearchChanged(e.target.value)}
                        />
                        <img
                          src={require('../../assets/images/icon_search_dark.svg')}
                          alt=""
                        />
                      </div>

                      <div className="container-users-card mt-4">{content}</div>

                      <img
                        className="settings-content-card-settings-icon-add pointer"
                        src={require('../../assets/images/icon_add.svg')}
                        data-toggle="modal"
                        data-target={`#${modalDataTarget}`}
                        hidden={editingUser || menu === CurrentMenu.voicebot}
                        alt=""
                        onClick={this.getOpenStatusModal}
                      />
                    </>
                  ) : (
                    <General />
                  )}
                </div>
                {/* MAIN CONTENT END */}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companies: state.companies,
    getCompaniesCompleted: state.companies.getCompaniesCompleted,
    organizations: state.companies.organizations,
    getOrganizationsCompleted: state.companies.getOrganizationsCompleted,
    permissions: state.permissions.permissions,
    getPermissionsCompleted: state.permissions.getPermissionsCompleted,
    users: state.users.users,
    userMe: state.users.signedUser,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...CompanyActions, ...UserActions, ...PermissionActions },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Settings))
);
